// src/App.tsx
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import AppRouter from './router';

const App: React.FC = () => {
  return (
    <StyleSheetManager 
      shouldForwardProp={(prop) => 
        isPropValid(prop) && 
        !['variant', 'size', 'fullWidth', 'error'].includes(prop)
      }
    >
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </ThemeProvider>
    </StyleSheetManager>
  );
};

export default App;